import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Box } from "@mui/material";
import {
  libraryAllCoursesHome,
  libraryAllCoursesInPerson,
  libraryAllCoursesOnline,
  libraryAllCoursesRecommended,
  libraryAllCoursesVirtual,
  libraryAllCoursesWebinar,
  learnLibraryAllCourses,
  routePermissions,
  libraryAllCoursesFavorites
} from "../../../routes/LearningCenterRoutes";
import LinkGroup from "../../../components/Nav/LinkGroup/LinkGroup";
import { useTranslation } from "react-i18next";
import { Route, Redirect } from "react-router-dom";
import AllCoursesHomeContainer from "../../../containers/LearningCenter/Library/AllCourses/AllCoursesHomeContainer";
import CoursesListContainer from "../../../containers/LearningCenter/Library/AllCourses/CoursesListContainer";
import { useIsIframed } from "../../../hooks/utils/iframeUtils";
import MyCoursesContainer from "../../../containers/LearningCenter/Library/MyItems/MyCoursesContainer";

const initialLinks = t => [
  {
    path: libraryAllCoursesHome,
    title: t("libraryAllCourses.tabs.home"),
    active: false
  },
  {
    path: libraryAllCoursesOnline,
    title: t("libraryAllCourses.tabs.onlineCourses"),
    active: false
  },
  {
    path: libraryAllCoursesWebinar,
    title: t("libraryAllCourses.tabs.webinars"),
    active: false,
    permission: routePermissions.libraryAllCoursesWebinar
  },
  {
    path: libraryAllCoursesVirtual,
    title: t("libraryAllCourses.tabs.virtualClassrooms"),
    active: false,
    permission: routePermissions.libraryAllCoursesVirtual
  },
  {
    path: libraryAllCoursesInPerson,
    title: t("libraryAllCourses.tabs.inPerson"),
    active: false,
    permission: routePermissions.libraryAllCoursesInPerson
  },
  {
    path: libraryAllCoursesFavorites,
    title: t("libraryAllCourses.tabs.favorites"),
    active: false
  },
  {
    path: libraryAllCoursesRecommended,
    title: t("libraryAllCourses.tabs.recommended"),
    active: false
  }
];

const LibraryAllCourses = ({
  history,
  user: { permissions },
  location: { pathname }
}) => {
  const { t } = useTranslation();
  const isIframed = useIsIframed();

  const [allCoursesLinks, setAllCoursesLinks] = useState(initialLinks(t));

  // filter out links user does not have permission to access
  useEffect(() => {
    const links = initialLinks(t);
    let updatedLinks = isIframed
      ? links.filter(link => link.path !== libraryAllCoursesHome)
      : links.filter(link => link.path !== libraryAllCoursesFavorites);

    updatedLinks = updatedLinks.filter(link =>
      link.permission ? permissions[link.permission] : true
    );

    updatedLinks = updatedLinks.map(link => ({
      ...link,
      active: link.path === pathname
    }));

    setAllCoursesLinks(updatedLinks);
  }, [permissions, isIframed, pathname]);

  return (
    <Box display="flex" flexDirection="column">
      <LinkGroup links={allCoursesLinks} history={history} />

      <Route
        exact
        path={learnLibraryAllCourses}
        render={() => <Redirect to={libraryAllCoursesHome} />}
      />
      <Route path={libraryAllCoursesHome} component={AllCoursesHomeContainer} />
      <Route path={libraryAllCoursesOnline} component={CoursesListContainer} />
      {permissions[routePermissions.libraryAllCoursesWebinar] && (
        <Route
          path={libraryAllCoursesWebinar}
          component={CoursesListContainer}
        />
      )}
      {permissions[routePermissions.libraryAllCoursesVirtual] && (
        <Route
          path={libraryAllCoursesVirtual}
          component={CoursesListContainer}
        />
      )}
      {permissions[routePermissions.libraryAllCoursesInPerson] && (
        <Route
          path={libraryAllCoursesInPerson}
          component={CoursesListContainer}
        />
      )}
      {isIframed && (
        <Route
          path={libraryAllCoursesFavorites}
          component={MyCoursesContainer}
        />
      )}
      <Route
        path={libraryAllCoursesRecommended}
        component={CoursesListContainer}
      />
    </Box>
  );
};

const mapStateToProps = state => {
  return {
    user: state.userState.user || { permissions: {} }
  };
};

LibraryAllCourses.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  match: PropTypes.any
};

export default connect(mapStateToProps)(LibraryAllCourses);
